export default {
    "Bem vindo(a) ao": "Willkommen bei",
    "Entre com suas credenciais": "Geben Sie Ihre Anmeldedaten ein",
    "do Ginfo abaixo": "von Ginfo unten",
    "Empresa": "Unternehmen",
    "empresa_login": "Unternehmen",
    "Selecione a empresa": "Unternehmen auswählen",
    "E-mail": "E-Mail",
    "Senha": "Passwort",
    "Lembrar de mim": "Angemeldet bleiben",
    "Entrar": "Anmelden",
    "Solicite seu acesso": "Zugriff anfordern",

    "Portugues": "Portugiesisch",
    "Mercosul": "Mercosur",
    "Ingles": "Englisch",
    "Frances": "Französisch",
    "Alemao": "Deutsch",
    "Holandes": "Niederländisch",
    "Carregando": "Wird geladen",
    'TODOS': 'ALLE',
    'BELGIUM': 'BELGIEN',
    'GERMANY': 'DEUTSCHLAND',
    'SELECIONE_O_PAIS': 'Wählen Sie das Land',
    'PAIS': 'Land',
    "inicio": "Startseite",
    "bem_vindo": "Willkommen bei",
    "ginfo_analytics": "GINFO Analytics",
    "informacoes_inteligentes": "Intelligente Informationen für schnellere, sichere und strategische Entscheidungen",
    "acessados_recentemente": "Zuletzt aufgerufen",
    "buscar_relatorio": "Bericht suchen",
    "nenhum_relatorio_encontrado": "Keine Berichte gefunden.",
    "acesso_power_bi": "Power BI-Zugriff",
    "ajuda": "Hilfe",
    "sair": "Abmelden",
    "agora": "jetzt",
    "ha": "vor",
    "minutos": "Min.",
    "horas": "Std.",
    "ontem": "gestern",
    "dias": "Tagen",
    "semanas": "Wochen",
    "buscar_abrir_relatorio": "Bericht suchen und öffnen",
    "mostrar_senha": "Passwort anzeigen",
    "ocultar_senha": "Passwort verbergen",
    "esqueceu_senha": "Passwort vergessen?",
    "login_frase_inicio": "Bessere Entscheidungen beginnen mit",
    "login_frase_destaque": "der richtigen Information",
    "login_frase_2": "dem richtigen Zeitpunkt",
    "login_frase_3": "dem richtigen Ort",
    "recarregar_relatorio": "Bericht aktualisieren",
    "fechar_aba": "Tab schließen",
    "horarios_atualizacao": "Aktualisierungszeiten",
    "tutorial_desta_tela": "Tutorial für diesen Bildschirm",
    "fechar": "Schließen",
    "carregando_tutorial": "Tutorial wird geladen...",
    "tutorial_indisponivel": "Tutorial für diesen Bildschirm derzeit nicht verfügbar.",
    "passo": "Schritt"
}
